<template>
    <el-form :model="rule" ref="forms" class="demo-ruleForm" label-width="100px">
        <el-form-item label="权限" prop="type">
            <el-checkbox v-model="rule.message">短信报警</el-checkbox>
            <el-checkbox v-model="rule.wechat">微信报警</el-checkbox>
            <el-checkbox v-model="rule.email">email报警</el-checkbox>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button @click="block">返回</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        data() {
            return {
                rule:{
                    id:0,
                    message: false,
                    wechat: false,
                    email: false
                },
            }
        },
        async created() {
            if(this.$route.params.id) {
                if(!!this.$store.state.editInfo) {
                    this.rule = this.$store.state.editInfo
                    delete this.rule.create_time
                    delete this.rule.ins_id
                    delete this.rule.ins_name
                    delete this.rule.update_time
                }else {
                    this.$router.push('/warn/qx/index');
                }
            }
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        this.$http.post('/manage/alert-channel/update',this.rule).then(rs => {
                            if(rs.data.code == 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.$router.push('/warn/qx/index');
                            }else {
                                this.$message({
                                    message: rs.data.message,
                                    type: 'error'
                                });
                            }
                        })
                    }
                });
            },
            block() {
                this.$router.go(-1);
            },
        }
    }
</script>